import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full p-4 flex flex-col gap-10" }

import { IonPage, IonContent } from '@ionic/vue';
import BaseData from '@/components/DetailPage/DataPage/BaseData.vue'
import CustomerData from '@/components/DetailPage/DataPage/CustomerData.vue'
import AdditionalData from '@/components/DetailPage/DataPage/AdditionalData.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DataPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BaseData),
            _createVNode(CustomerData),
            _createVNode(AdditionalData)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})